import React from "react";

const ShippingPolicyComponent = () => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1440px",
        minHeight: "100vh",
        background: "linear-gradient(172.67deg, #fffbf9 5.7%, #f7ece3 60.35%)",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: "30px 60px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "24px",
            color: "#333",
          }}
        >
          Shipping & Delivery Policy
        </h1>

     
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
         Shipping is not applicable for Business.
        </p>
       

       
      </div>
    </div>
  );
};

export default ShippingPolicyComponent;